import React, { FC } from "react";
import { Avatar, Stack, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  name: string;
  title?: string;
  image?: string;
}

const Profile: FC<Props> = ({ name, title, image }) => {
  return (
    <Stack mb={3} direction="row" alignItems="center" gap="10px">
      {image && <Avatar src={image} sx={{ width: "60px", height: "60px" }} />}
      <Stack>
        <Typography
          variant="h6"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "300",
            color: Colors.PrimaryMain,
          }}
        >
          {name}
        </Typography>
        {title && (
          <Typography
            variant="body1"
            sx={{
              fontSize: "14px",
              lineHeight: "22px",
              fontWeight: "300",
              color: Colors.PrimaryMain,
            }}
          >
            {title}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default Profile;
